import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject
} from '@angular/core';
import { SecurityFacade } from '@core/ngrx/facades/security.facade';
import { take } from 'rxjs/operators';

interface AccessCheck {
  roles?: string[];
  permissions?: string[];
}

@Directive({
  selector: '[appHasAccess]',
  standalone: false
})
export class AppHasAccessDirective {
  private config?: AccessCheck;
  private elseTemplate?: TemplateRef<any>;

  private viewContainer = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef<any>);
  private securityFacade = inject(SecurityFacade);

  @Input() set appHasAccess(config: AccessCheck) {
    this.config = config;
    this.subscribeToAccessChanges();
  }

  @Input() set appHasAccessElse(ref: TemplateRef<any>) {
    this.elseTemplate = ref;
  }

  private subscribeToAccessChanges() {
    this.securityFacade.userAccess$
        .pipe(take(1))
        .subscribe(({ roles, permissions }) => {
          this.updateView(roles, permissions);
        });
  }

  private updateView(userRoles: string[], userPermissions: string[]) {
    const rolesOk =
        !this.config?.roles || this.config.roles.some(r => userRoles.includes(r));

    const permsOk =
        !this.config?.permissions ||
        this.config.permissions.some(p => userPermissions.includes(p));

    const isAllowed = rolesOk && permsOk;

    this.viewContainer.clear();

    if (isAllowed) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.elseTemplate) {
      this.viewContainer.createEmbeddedView(this.elseTemplate);
    }
  }
}
